import { render, staticRenderFns } from "./ProcessShareDialog.vue?vue&type=template&id=60ac5771"
import script from "./ProcessShareDialog.vue?vue&type=script&lang=js"
export * from "./ProcessShareDialog.vue?vue&type=script&lang=js"
import style0 from "./ProcessShareDialog.vue?vue&type=style&index=0&id=60ac5771&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports